import { useQuery as useUrqlQuery } from 'urql';
import { accountQuery } from '../graphql/account/accountQuery';

export const useAccountQuery = () => {
  const [urqlResult] = useUrqlQuery({
    query: accountQuery,
  });

  return urqlResult;
};
